module.exports = __webpack_public_path__ + "img/Kibe67.72259a55.jpg";